export default "__VITE_ASSET__0c9ce477__"